<!-- Контейнер быстрых действий по ТС на главной странице. -->
<template>
  <HomeSection title="Быстрые действия">
    <!-- TODO: прокинуть page access checks для ссылок на списки, когда быстрые действия получат единый permission contract. -->
    <HomeExpenseAction />
    <HomeVehicleProblemAction />
    <HomeVehicleInspectionAction v-if="canCreateInspection" />
    <HomeVehicleRepairAction />
  </HomeSection>
</template>

<script>
import HomeExpenseAction from "@/components/Home/ExpenseAction.vue";
import HomeSection from "@/components/Home/Section.vue";
import HomeVehicleProblemAction from "@/components/Home/VehicleProblemAction.vue";
import HomeVehicleInspectionAction from "@/components/Home/VehicleInspectionAction.vue";
import HomeVehicleRepairAction from "@/components/Home/VehicleRepairAction.vue";
import { can } from "@/utils/permissionUtils";

export default {
  name: "HomeVehicleQuickActions",

  components: {
    HomeExpenseAction,
    HomeSection,
    HomeVehicleProblemAction,
    HomeVehicleInspectionAction,
    HomeVehicleRepairAction,
  },

  computed: {
    canCreateInspection() { return can("Fleet::Vehicle::Inspection", "create"); },
  },
};
</script>
